import React, { useContext } from "react";
import UserContext from "../State/UserContext";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const { user } = useContext(UserContext);

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        user.user ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
}

export default ProtectedRoute;
